import BlockSizeSelector from './block-size-selector';

export default BlockSizeSelector;
